<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>项目配置</el-breadcrumb-item>
            <el-breadcrumb-item>规则配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <div class="children">
              <div style="width:78%"></div>
              <div style="display:flex;width:10%;align-items:center">
                   企业端
                   <el-switch
                    class="font12"
                    active-value="1"
                    inactive-value="2"
                    inactive-text="关闭"
                    @change="changSta(item1.entProjectConfig.projectSwitch,item1)"
                  ></el-switch>
              </div>
                <div style="display:flex;width:10%;align-items:center">
                   项目端
                   <el-switch
                    class="font12"
                    active-value="1"
                    inactive-value="2"
                    inactive-text="关闭"
                    @change="changSta(item1.entProjectConfig.projectSwitch,item1)"
                  ></el-switch>
              </div>
          </div>
          <!-- 项目平台 -->
          <div style="text-align:left;margin-bottom:10px;" v-for="(item,index) in list" :key="index">
            <div class="display-item">
              <div style="width:100%;font-size:24px">{{item.configContent}}</div>
              <div class="children" v-for="(item1,index1) in item.children" :key="index1">
                <!-- 有输入框的 -->
                <div style="width:100%;display:flex">
                  <div style="width:83%;display:flex" class="font12">
                    <div  v-if="item1.configContent.indexOf('_')>-1">{{item1.configContent.split('_')[0]}}</div>
                    <el-input  v-if="item1.configContent.indexOf('_')>-1" style="width:65px;" class="font12" v-model="item1.entProjectConfig.configValue"></el-input>
                    <div  v-if="item1.configContent.indexOf('_')>-1" >{{item1.configContent.split('_')[1]}}</div>
                    <div v-if="item1.configContent.indexOf('_')==-1">{{item1.configContent}}</div>
                  </div>
                  <el-switch
                    style="width:10%"
                    class="font12"
                    active-value="1"
                    inactive-value="2"
                    v-model="item1.entProjectConfig.projectSwitch"
                    inactive-text="关闭"
                    @change="changSta(item1.entProjectConfig.projectSwitch,item1)"
                  ></el-switch>
                  <el-switch
                    style="width:10%"
                    class="font12"
                    active-value="1"
                    inactive-value="2"
                    v-model="item1.entProjectConfig.projectSwitch"
                    inactive-text="关闭"
                    @change="changSta(item1.entProjectConfig.projectSwitch,item1)"
                  ></el-switch>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      groupId: '',
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      type: '',
      list: [],
      projectSwitch: '', //项目开关
      entSwitch:'',  //企业开关
      configId: '',
      configValue: '', //配置值
      configType: '', //配置规则类型
      configValue:'', //配置规则值
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    if (util.session.get('roleId') == '3') {
      this.type = '3'
    } else if (this.$store.state.roleId == '4') {
      this.type = '2'
    } else if (this.$store.state.roleId == '5') {
      this.type = '1'
    }
    this.getData()
  },
  methods: {
    //获取数据
    getData() {
      var that = this
      myHttp
        .configList({
          entId: this.groupId,
          type: this.type,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            that.list = resp.data.data.enterpriseConfigList || []
          } else {
            that.dataText = '暂无数据'
          }
        })
    },
    changSta(value, data) {
      var that = this
      console.log(data,data.entProjectConfig.projectSwitch)
      this.projectSwitch = value
      this.configId = data.entProjectConfig.configId
      this.configType = data.configType
      this.configValue = data.entProjectConfig.configValue
      myHttp
        .editConfig({
          projectId: this.groupId,
          type: this.type,
          projectSwitch: this.projectSwitch,
          configId: this.configId,
          configType: this.configType,
          configValue:this.configValue
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('设置成功')
          } else {
              data.entProjectConfig.projectSwitch=2
             that.$message.error(resp.data.msg)
          }
        })
    },
  
  
  },
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 1% !important;
  height: 100% !important;
  overflow: auto;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.display-item {
  /* display: flex; */
  align-items: center;
  padding: 10px 0px;
}
.content >>> .el-input__inner {
  height: 27px !important;
  line-height: 27px !important;
}
.error-color {
  color: #f00;
}
.font12 {
  font-size: 16px;
}
.children {
  display: flex;
  margin: 20px 0px;
  margin-left: 90px;
}
</style>